import { ApostleBountyFilterInput } from '@apeiron/apostle'
import { BountySortBy } from '@apeiron/bounty'
import { recursiveToString } from '@apeiron/common'
import useFilterQuery, {
  FilterQueryHook,
  FilterQueryProps
} from '@src/hooks/common/router/useFilterQuery'
import { extractArray, extractValue } from '@src/util/tools/query'
import { ParsedUrlQuery } from 'querystring'
import * as R from 'ramda'
import { useMemo } from 'react'

const useApostleBountyFilterQuery = (props?: Props): Hook => {
  const filledProps = useMemo(() => {
    const supportUrl = R.propOr(true, 'supportUrl', props) as boolean

    const toFilter = (query: ParsedUrlQuery): ApostleBountyFilterInput => {
      return {
        classes: recursiveToString(extractArray(query, 'classes')),
        firstSkillIDs: recursiveToString(extractArray(query, 'firstSkillIDs')),
        otherSkillIDs: recursiveToString(extractArray(query, 'otherSkillIDs')),
        minSkillLevelLowerBound: extractValue<number>(
          query,
          'minSkillLevelLowerBound'
        ),
        minSkillLevelUpperBound: extractValue<number>(
          query,
          'minSkillLevelUpperBound'
        ),
        minIVLowerBound: extractValue<number>(query, 'minIVLowerBound'),
        minIVUpperBound: extractValue<number>(query, 'minIVUpperBound')
      }
    }

    const toSort = () => ({ sortBy: BountySortBy.PriceDesc })

    return {
      supportUrl,
      queryToFilterInput: toFilter,
      queryToSortInput: toSort,
      excludedSearchParams: ['page']
    }
  }, [props])

  const {
    filterInput,
    isReady,
    sortInput,
    setBothInput,
    setFilterInput,
    setSortInput
  } = useFilterQuery<ApostleBountyFilterInput, BountySortBy>(filledProps)

  return {
    filterInput,
    isReady,
    sortInput,
    setBothInput,
    setFilterInput,
    setSortInput
  }
}

type Props = Omit<
  FilterQueryProps<ApostleBountyFilterInput, BountySortBy>,
  'queryToFilterInput' | 'queryToSortInput'
>

type Hook = FilterQueryHook<ApostleBountyFilterInput, BountySortBy>

export default useApostleBountyFilterQuery
